import _defineProperty from 'babel-runtime/helpers/defineProperty';
import { publish, subscribe } from '@wh/message-bus';
import { StateType as SessionServiceStateType } from '@central-products/interface-session-service';

import { EVENT_SESSION_SERVICE_STATE_CHANGED, commandMyAccountStart, commandMyAccountCancel } from './events';

export default (function () {
  var _SESSION_STATES;

  var SESSION_STATES = (_SESSION_STATES = {}, _defineProperty(_SESSION_STATES, SessionServiceStateType.SESSION_UNKNOWN, commandMyAccountCancel), _defineProperty(_SESSION_STATES, SessionServiceStateType.NO_SESSION, commandMyAccountCancel), _defineProperty(_SESSION_STATES, SessionServiceStateType.SESSION_EXISTS, commandMyAccountStart), _SESSION_STATES);

  subscribe({
    topic: EVENT_SESSION_SERVICE_STATE_CHANGED,
    callback: function callback(_ref) {
      var state = _ref.data.state;

      if (SESSION_STATES[state]) {
        publish(SESSION_STATES[state]);
      }
    }
  });
});